import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 数据采集
 */
const collection = {

  /**
   * 新增终端类别
   */
  addCollectionTerminalClassification (id, name) {
    return axios.post(base.collection.addCollectionTerminalClassification, utils.postParamsArrayToJsonString({ id, name }))
  },
  /**
   * 修改终端类别
   */
  modifyCollectionTerminalClassification (id, name) {
    return axios.post(base.collection.modifyCollectionTerminalClassification, utils.postParamsArrayToJsonString({ id, name }))
  },
  /**
   * 查询终端类别
   */
  getCollectionTerminalClassifications () {
    return axios.post(base.collection.getCollectionTerminalClassifications, utils.postParamsArrayToJsonString({}))
    // return utils.simulateReslut([{ id: 1, name: '测试' }])
  },
  /**
   * 删除终端类别
   */
  deleteCollectionTerminalClassifications (ids) {
    return axios.post(base.collection.deleteCollectionTerminalClassifications, utils.postParamsArrayToJsonString({ ids }))
  },
  /**
   * 新增终端参数模板
   */
  addCollectionTerminalParamTemplate (name, classification) {
    return axios.post(base.collection.addCollectionTerminalParamTemplate, utils.postParamsArrayToJsonString({ name, classification }))
  },
  /**
   * 修改终端参数模板
   */
  modifyCollectionTerminalParamTemplate (id, name) {
    return axios.post(base.collection.modifyCollectionTerminalParamTemplate, utils.postParamsArrayToJsonString({ id, name }))
  },
  /**
   * 查询终端参数模板
   */
  getCollectionTerminalParamTemplates () {
    return axios.post(base.collection.getCollectionTerminalParamTemplates, utils.postParamsArrayToJsonString({}))
  },
  /**
   * 删除终端参数模板
   */
  deleteCollectionTerminalParamTemplates (ids) {
    return axios.post(base.collection.deleteCollectionTerminalParamTemplates, utils.postParamsArrayToJsonString({ ids }))
  },
  /**
   * 设置终端参数模板项
   */
  setCollectionTerminalParamTemplateItems (templateId, params) {
    return axios.post(base.collection.setCollectionTerminalParamTemplateItems, utils.postParamsArrayToJsonString({ templateId, params }))
  },
  /**
   * 查询终端参数模板项
   */
  getCollectionTerminalParamTemplateItems (templateId) {
    return axios.post(base.collection.getCollectionTerminalParamTemplateItems, utils.postParamsArrayToJsonString({ templateId }))
    // return utils.simulateReslut([{ param: '测试', value: '111' }])
  },
  /**
   * 新增采集中心
   */
  addCollectionCenter (name, key) {
    return axios.post(base.collection.addCollectionCenter, utils.postParamsArrayToJsonString({ name, key }))
  },
  /**
   * 修改采集中心
   */
  modifyCollectionCenter (id, name, key) {
    return axios.post(base.collection.modifyCollectionCenter, utils.postParamsArrayToJsonString({ id, name, key }))
  },
  /**
   * 查询采集中心
   */
  getCollectionCenters () {
    return axios.post(base.collection.getCollectionCenters, utils.postParamsArrayToJsonString({}))
  },
  /**
   * 删除采集中心
   */
  deleteCollectionCenters (ids) {
    return axios.post(base.collection.deleteCollectionCenters, utils.postParamsArrayToJsonString({ ids }))
  },
  /**
   * 新增采集数据仓库
   */
  addCollectionRepository (name, dbHost, dbPort, dbUserName, dbPassword, centerId) {
    return axios.post(base.collection.addCollectionRepository, utils.postParamsArrayToJsonString({ name, dbHost, dbPort, dbUserName, dbPassword, centerId }))
  },
  /**
   * 修改采集数据仓库
   */
  modifyCollectionRepository (id, name, dbHost, dbPort, dbUserName, dbPassword, centerId) {
    return axios.post(base.collection.modifyCollectionRepository, utils.postParamsArrayToJsonString({ id, name, dbHost, dbPort, dbUserName, dbPassword, centerId }))
  },
  /**
   * 查询采集数据仓库
   */
  getCollectionRepositories (centerId) {
    return axios.post(base.collection.getCollectionRepositories, utils.postParamsArrayToJsonString({ centerId }))
  },
  // /**
  //  * 查询采集数据仓库
  //  */
  // getCollectionRepositories2 (centerId) {
  //   return axios.post(base.collection.getCollectionRepositories2, utils.postParamsArrayToJsonString({ centerId }))
  // },
  /**
   * 删除采集数据仓库
   */
  deleteCollectionRepositories (ids) {
    return axios.post(base.collection.deleteCollectionRepositories, utils.postParamsArrayToJsonString({ ids }))
  },
  /**
   * 新增采集终端
   */
  addCollectionTerminal (measureId, name, measureTemplateId, mountOn, address, assignedServiceNode, parentId, paramTemplateId, enable, repositoryId) {
    return axios.post(base.collection.addCollectionTerminal, utils.postParamsArrayToJsonString({ measureId, name, measureTemplateId, mountOn, address, assignedServiceNode, parentId, paramTemplateId, enable, repositoryId }))
  },
  /**
   * 修改采集终端
   */
  modifyCollectionTerminal (measureId, address, assignedServiceNode, parentId, paramTemplateId, enable, repositoryId) {
    return axios.post(base.collection.modifyCollectionTerminal, utils.postParamsArrayToJsonString({ measureId, address, assignedServiceNode, parentId, paramTemplateId, enable, repositoryId }))
  },
  /**
   * 查询采集终端
   */
  getCollectionTerminal (measuresId) {
    return axios.post(base.collection.getCollectionTerminal, utils.postParamsArrayToJsonString({ measuresId }))
  },
  /**
   * 查询采集终端
   */
  getCollectionTerminal2 (repositoryId, address) {
    return axios.post(base.collection.getCollectionTerminal2, utils.postParamsArrayToJsonString({ repositoryId, address }))
  },
  /**
   * 查询采集终端
   */
  getCollectionTerminal3 (paramTemplateId) {
    return axios.post(base.collection.getCollectionTerminal3, utils.postParamsArrayToJsonString({ paramTemplateId }))
  },
  /**
   * 查询采集终端
   */
  getCollectionTerminal4 (parentIds) {
    return axios.post(base.collection.getCollectionTerminal4, utils.postParamsArrayToJsonString({ parentIds }))
  },
  /**
   * 删除采集终端
   */
  deleteCollectionTerminals (ids) {
    return axios.post(base.collection.deleteCollectionTerminals, utils.postParamsArrayToJsonString({ ids }))
  },
  /**
   * 查询采集服务
   */
  listCollectionServices (centerId) {
    return axios.post(base.collection.listCollectionServices, utils.postParamsArrayToJsonString({ centerId }))
  },


  /**
   * 增加采系统服务
   */
  addCollectionService (centerId, key, type, weight, params, enable) {
    return axios.post(base.collection.addCollectionService, utils.postParamsArrayToJsonString({ centerId, key, type, weight, params, enable }))
  },
  /**
   * 修改采系统服务
   */
  modifyCollectionServices (centerId, key, type, weight, params, enable) {
    return axios.post(base.collection.modifyCollectionServices, utils.postParamsArrayToJsonString({ centerId, key, type, weight, params, enable }))
  },
  /**
   * 删除采系统服务
   */
  deleteCollectionServices (centerId, key) {
    return axios.post(base.collection.deleteCollectionServices, utils.postParamsArrayToJsonString({ centerId, key }))
  },
  /**
   * 同步采集档案
   */
  synchronizeArchiveForCollectionServices (centerId) {
    return axios.post(base.collection.synchronizeArchiveForCollectionServices, utils.postParamsArrayToJsonString({ centerId }))
  },
  // /**
  //  * 同步采集档案
  //  */
  // synchronizeArchiveForCollectionServices2 (repositoryId) {
  //   return axios.post(base.collection.synchronizeArchiveForCollectionServices2, utils.postParamsArrayToJsonString({ repositoryId }))
  // },
  /**
   * 注册采集终端
   */
  registerCollectionTerminal (measureId, address, assignedServiceNode, parentId, paramTemplateId, enable, repositoryId) {
    return axios.post(base.collection.registerCollectionTerminal, utils.postParamsArrayToJsonString({ measureId, address, assignedServiceNode, parentId, paramTemplateId, enable, repositoryId }))
  },
}

export default collection